// src/belediye/components/authz/PermissionGate.js
//
// FAZ-12 — sayfa sarıcı. Bu fazda HİÇBİR route'a takılmaz (FAZ-13'ün işi);
// yalnız bileşen + testleri hazırlanır.
//
// Davranış:
//   uiOn=false → çocukları AYNEN render eder (pasif — eski yol bozulmaz)
//   uiOn=true  → canAny(permissions) değilse /yetkisiz'e Navigate

import { Navigate } from "react-router-dom";

import usePermissions from "../../hooks/usePermissions";

export default function PermissionGate({ permissions = [], children }) {
  const { uiOn, canAny } = usePermissions();

  if (!uiOn) return children;
  if (!canAny(permissions)) return <Navigate to="/yonetim/yetkisiz" replace />;
  return children;
}
